import { RdxContextType } from './rdx-context-type.enum';

export class RdxContext {
    contextType: RdxContextType;
    contextId: number;
    companyId?: number;

    constructor(contextType: RdxContextType, contextId: number) {
        this.contextType = contextType;
        this.contextId = contextId;
    }
}
